/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module DeleteVsDialogModule */

import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';
import * as l10n from './delete-vs-dialog.l10n';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Dialog popup for deleting a VS from the VS List page. Allows users to delete a VS and/or its
 *     referenced objects.
 * @author alextsg
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'delete-vs-dialog',
    templateUrl: './delete-vs-dialog.component.html',
})
export class DeleteVsDialogComponent {
    @Output()
    public onClose = new EventEmitter<void>();

    @Output()
    public onDelete = new EventEmitter<boolean>();

    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    public deleteReferencedObjects = false;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    public handleClose(): void {
        this.onClose.emit();
    }

    public handleDelete(): void {
        this.onDelete.emit(this.deleteReferencedObjects);
    }
}
